import { render } from "./goods-edit-draw.vue?vue&type=template&id=c09d436c&scoped=true"
import script from "./goods-edit-draw.vue?vue&type=script&lang=js"
export * from "./goods-edit-draw.vue?vue&type=script&lang=js"

import "./goods-edit-draw.vue?vue&type=style&index=0&id=c09d436c&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c09d436c"]])

export default __exports__